export type UserType = {
  name: string
  email: string
  avatar: string
}

// Company information
export const companyInfo = {
  name: "ABT meeting",
  shortName: "ABT",
  description: "Hệ thống họp trực tuyến",
}

// Application metadata
export const appMetadata = {
  title: "ABT - Hệ thống họp trực tuyến",
  description: "Hệ thống quản lý cuộc họp",
  version: "1.0.0",
} 